// composables/useUbicacionUsuario.js
import { NEGOCIOS } from "~/constants/negocios";
import { procesarComponentesDireccion } from "~/composables/useGoogleServices";

export default function useUbicacionUsuario() {
  const modo_sistema = useState('modo_sistema');

  const {
    ubication,
    getAddresses,
    setUbication,
    setLocalPivote,
    setAddress,
    setShowAddressOptions,
    setShowLeaveAddress,
    setLeaveAddress,
  } = useCartBridge();

  const apiobtenerLocalCercano = async (direccion) => {
    let businessId;
    if (modo_sistema.value === NEGOCIOS.NEUMATICOS) businessId = 1;
    else if (modo_sistema.value === NEGOCIOS.BATERIAS) businessId = 2;
    else if (modo_sistema.value === NEGOCIOS.ACEITES) businessId = 11;

    try {
      const response = await $fetch('/api/locales', {
        method: 'GET',
        params: {
          action: 'local-cercano',
          negocio_id: businessId,
          ubicacion: direccion,
        },
      });

      if (response.status === 'success') {
        return response.data;
      }

      console.error("Error en la respuesta del servidor:", response);
      return null;
    } catch (error) {
      console.error("Error al obtener local cercano:", error);
      return null;
    }
  };

  function obtenerLocalCercano(ubi) {
    return apiobtenerLocalCercano(ubi.address || `${ubi.latitude},${ubi.longitude}`);
  }

  function guardarUbicacion(ubi, localpivote) {
    ubi.isLoading = false;

    const direccion = {
      address: ubi.address || "",
      comments: "",
      commune: ubi.commune || "",
      details: ubi.streetNumber || "",
      latitude: ubi.latitude || "",
      longitude: ubi.longitude || "",
      region: ubi.region || "",
    };

    const leave = {
      address: "",
      comments: "",
      commune: "",
      details: "",
      latitude: "",
      longitude: "",
      region: "",
    };

    setLocalPivote(localpivote);
    setUbication(ubi);

    getAddresses();
    setAddress(direccion);
    setShowAddressOptions(false);
    setShowLeaveAddress(false);
    setLeaveAddress(leave);
  }

  async function seleccionarUbicacion(place, coords) {
    const ubicacionAnterior = ubication.value;

    try {
      setUbication({ ...ubicacionAnterior, isLoading: true });

      const locationData = procesarComponentesDireccion(place, coords);
      const localpivote = await obtenerLocalCercano(locationData);

      guardarUbicacion(locationData, localpivote);
      return locationData;
    } catch (error) {
      setUbication({ ...ubicacionAnterior, isLoading: false });
      throw error;
    }
  }

  return { seleccionarUbicacion, guardarUbicacion, obtenerLocalCercano, apiobtenerLocalCercano };
}